import React from 'react'
import { StoreWrap } from 'xadmin'
import { use, api, app } from 'xadmin';
import { Result, Button, Alert, Spin } from 'antd'
const UpgradelicenseCard = React.lazy(() => import('../components/UpgradelicenseCard'))

const NoLicensePage = StoreWrap('auth.user')((props) => {
  const { user, onLogout } = props
  // const projectId = _.get(api({ name: 'media' }).getHeaders(), 'x-request-project')
  const title = (user?.isAdmin) ? "您的授权已到期！为了不影响您的使用，请及时续费。" : "平台授权已到期！为了不影响您的使用，请联系管理员上传授权文件"
  const getLogoutLog = e => {
    api({ name: 'core/auth/logout' }).fetch('')
  }
  return (<>
    <Result style={{ height: 200, marginTop: user?.isAdmin ? 70 : 170 }} status="warning"
      title={title}
      extra={
        <>
          <Button type="primary" key="console" onClick={() => app.go('/app/dashboard')}>
            重新加载
          </Button>
          <Button type="primary" key="console" onClick={() => { getLogoutLog(); onLogout() }}>
            退出登录
          </Button>
        </>
      }>
      {user?.isAdmin && <div style={{ width: '70%', margin: '0 auto' }}>
        <React.Suspense fallback={<Spin />}>
          <UpgradelicenseCard />
        </React.Suspense>
      </div>}
    </Result>
  </>)
})

export default {
  routers: {
    '/': [
      {
        path: 'nolicense',
        component: NoLicensePage
      },
    ]
  },
}
